"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var classnames_1 = require("./classnames");

var Button = function Button(_ref) {
  var handleClick = _ref.handleClick,
      label = _ref.label,
      background = _ref.background,
      font = _ref.font;
  return React.createElement("div", {
    className: classnames_1.container
  }, React.createElement("button", {
    className: classnames_1.primary(background, font),
    onClick: handleClick
  }, label));
};

exports.default = Button;